import {validateRecipe} from './compost-plan.mjs';

export function ingredientDensity(value, unit = 'lb/ft3') {
  if (unit !== 'lb/ft3') throw new Error('Ingredient density must use lb/ft³.');
  if (value == null || value === '') return null;
  if (!['number','string'].includes(typeof value) || !Number.isFinite(Number(value)) || Number(value) <= 0 || Number(value) > 5000) throw new Error('Ingredient density must be positive and at most 5,000 lb/ft³.');
  return Number(value);
}
function quantity(value) {
  if (value == null || value === '') return null;
  if (!['number','string'].includes(typeof value) || !Number.isFinite(Number(value)) || Number(value) < 0 || Number(value) > 1e9) throw new Error('Invalid batch quantity.');
  return Number(value);
}
// Allocate display rounding residuals deterministically; never change stored amounts.
export function roundedAmounts(values, places = 2) {
  const factor = 10 ** places;
  const known = values.filter(v => v !== null);
  let remaining = Math.round(known.reduce((s,v) => s+v,0)*factor) - known.reduce((s,v) => s+Math.floor(v*factor),0);
  const order = values.map((v,i)=>({i,f:v===null?-1:v*factor-Math.floor(v*factor)})).sort((a,b)=>b.f-a.f||a.i-b.i);
  const extras = new Set(order.filter(v=>v.f>=0).slice(0,remaining).map(v=>v.i));
  return values.map((v,i)=>v===null?null:(Math.floor(v*factor)+(extras.has(i)?1:0))/factor);
}
export function recipeBreakdown(recipe, batch) {
  validateRecipe(recipe, true);
  if (batch.volumeUnit && batch.volumeUnit !== 'yd3' || batch.massUnit && batch.massUnit !== 'us_ton') throw new Error('Use cubic yards and US short tons.');
  const volume = quantity(batch.volume), tons = quantity(batch.tons);
  const anchor = recipe.basis === 'volume' ? volume : tons;
  const rows = recipe.lines.map(line => {
    const density = ingredientDensity(line.densityLbsPerCuft, line.densityUnit ?? 'lb/ft3');
    const allocated = anchor === null ? null : anchor*line.percent/100;
    return {...line,density,volume:recipe.basis==='volume'?allocated:allocated===null||density===null?null:allocated*2000/(27*density),tons:recipe.basis==='mass'?allocated:allocated===null||density===null?null:allocated*27*density/2000};
  });
  const total = key => rows.some(r=>r[key]===null)?null:rows.reduce((s,r)=>s+r[key],0);
  const estimatedVolume=total('volume'), estimatedTons=total('tons');
  const displayedVolume=roundedAmounts(rows.map(r=>r.volume)), displayedTons=roundedAmounts(rows.map(r=>r.tons));
  return {basis:recipe.basis,anchor,rows:rows.map((r,i)=>({...r,displayVolume:displayedVolume[i],displayTons:displayedTons[i]})),volume:estimatedVolume,tons:estimatedTons,volumeDelta:estimatedVolume===null||volume===null?null:estimatedVolume-volume,tonsDelta:estimatedTons===null||tons===null?null:estimatedTons-tons};
}

// Metadata and ingredient targets identify an unchanged recipe; densities/names belong to its saved snapshot.
export function sameRecipeTargets(draft, snapshot) {
  if (!draft || !snapshot) return false;
  const key = recipe => JSON.stringify({name:recipe.name,basis:recipe.basis,templateId:recipe.templateId??null,templateVersion:recipe.templateVersion??null,lines:recipe.lines.map(l=>({ingredientId:l.ingredientId,percent:l.percent}))});
  return key(draft) === key(snapshot);
}
